
<template>
  <div class="landing-body" :class="{'landing-menu-active': menuActive}" style="min-height: 100vh">
    <div class="landing-wrapper">
        <div id="header">
            
            <div class="header-top">
                <!-- <span class="logo">伴生质子束用户系统</span> -->
                <!-- {{ screenWidth }} -->
                <img v-if="isMobile" src="../assets/images/logo.png" style="height: 30px;" class="logo" alt="Associated proton"/>
                <img v-else src="../assets/images/logo.png" style="height: 50px;" class="logo" alt="Associated proton"/>
                <a id="landing-menu-button" href="#" @click="onMenuButtonClick">
                    <img src="../../public/assets/layout/images/landing/icon-menu.svg" alt="Menu"/>
                </a>
                <ul id="landing-menu">
                    <li>
                        <a href="/login" @click="hideMenu">登录</a>
                    </li>
                    <li>
                        <a href="https://login.csns.ihep.ac.cn" @click="hideMenu">注册</a>
                    </li>
                    <li>
                        <a href="https://login.csns.ihep.ac.cn" @click="hideMenu">忘记密码</a>
                    </li>
                </ul>
            </div>

            <!-- <div class="header-content" style="min-height: 500px;">
                <div class="header-content-text">
                    <h1 style="color: darkcyan">伴生质子束用户系统</h1>
                    <p>点击登录</p>
                    <br>
                    
                    <button type="button" class="landing-button" onclick="window.location.href='/login'" >
                        <span>登录</span>
                    </button>

                    <div style="margin-top: 20px">
                        <a href="https://login.csns.ihep.ac.cn">注册</a>
                        <a href="https://login.csns.ihep.ac.cn" style="margin-left: 30px">忘记密码</a>
                    </div>
                </div>
            </div> -->

            <div class="p-grid" style="min-height: 500px; width: 100%; background: white;">
                <div class="p-col-12" style="padding: 0">
                    <img v-if="isMobile" src="../assets/images/csns_campus2.jpg" style="height: 150px; width: 100%; border-radius: 0px;" alt="csns-campus"/>
                    <img v-else src="../assets/images/csns_campus2.jpg" style="height: 400px; width: 100%; border-radius: 0px;" alt="csns-campus"/>
                </div>
                <div class="p-col-12 p-md-8" style="border: 2px solid gray; border-radius: 0px;">
                    <div class="p-grid">
                        <div class="p-col-12 p-order-0 p-order-md-0" style="background-color: paleturquoise;">
                            <div style="text-align: center; color: RGB(33, 150, 243); font-size: 2em; font-weight: bold;">伴生质子束实验平台简介</div>
                        </div>
                        <div class="p-col-12 p-md-6 p-order-2 p-order-md-1">
                            <img src="../assets/images/apep_position.png" style="height: 300px; width: 100%; border-radius: 0px; border: 2px solid #555; padding: 5px;" alt="apep-position"/>
                            <div style="text-align: center; color: RGB(33, 150, 243); margin-top: 5px;">CSNS装置布局及伴生质子束位置</div>
                            <br>
                            <img src="../assets/images/apep_principle.png" style="height: 300px; width: 100%; border-radius: 0px; border: 2px solid #555; padding: 5px;" alt="apep-principle"/>
                            <div style="text-align: center; color: RGB(33, 150, 243); margin-top: 5px;">伴生质子束实验平台</div>
                        </div>
                        <div class="p-col-12 p-md-6 p-order-1 p-order-md-2">
                            <p style="font-size: 1.1em; text-indent: 2em;" class="align-both-ends">中国散裂中子源（CSNS）是开展多学科前沿研究的大型科研平台。CSNS一期工程利用一台直线加速器(LINAC)将负氢离子加速到80MeV，之后负氢离子被剥离成质子并被注入到快循环质子同步加速器(RCS)中加速至1.6GeV，引出并轰击钨靶产生大量的中子。</p>
                            <p style="font-size: 1.1em; text-indent: 2em;" class="align-both-ends">负氢离子束在LINAC中加速和传输时，会与真空管中的残余气体相互作用，少部分负氢离子被剥离成质子，即伴生质子，这部分质子会随着负氢离子束传输到CSNS直线加速器末端。将这部分伴生质子引出，并在隧道中搭建伴生质子束实验平台（APEP），开展质子辐照应用相关的实验及测试研究，包括电子器件及集成电路的辐照效应研究、半导体材料的辐照损伤效应和改性、加速器装置上结构材料的辐照损伤、质子束的活化分析、质子探测器的标定实验研究等方向。借助于CSNS装置的优势，每年可以提供近5000小时的束流时间，适合开展辐照周期长的实验研究。在2021年底提供束流，它的建成弥补了国内中能质子实验束流时间的不足。</p>
                            <h4 style="color: RGB(33, 150, 243);">质子束参数指标</h4>
                            <p style="font-size: 1.1em; text-indent: 0;">能量范围：10-80 MeV (&gt;30MeV情况下的能散(FWHM)&lt;8.65%)</p>
                            <p style="font-size: 1.1em; text-indent: 0;">束斑尺寸：10 x 10 mm<sup>2</sup> – 50 x 50 mm<sup>2</sup>（连续可调方形束斑）</p>
                            <p style="font-size: 1.1em; text-indent: 0;">质子流强：10<sup>7</sup>-10<sup>10</sup> p/cm<sup>2</sup>/s</p>
                            <p style="font-size: 1.1em; text-indent: 0;">流强监测：1. CT提供降能前的实时流强数据</p>
                            <p style="font-size: 1.1em; text-indent: 5em;">2. 末端法拉第筒提供样品出流强数据</p>
                            <p style="font-size: 1.1em; text-indent: 5em;">3. 二次电子监督器提供样品前的实时流强数据</p>
                            <p style="font-size: 1.1em; text-indent: 5em;">4. 活化片标定样品位置流强</p>
                            <p style="font-size: 1.1em; text-indent: 0;">束线高度：1.2米</p>
                            <p style="font-size: 1.1em; text-indent: 0;">真空测试点：真空度10<sup>-3</sup> Pa，测试工位5个；圆形真空罐内径Ø0.8m</p>
                            <p style="font-size: 1.1em; text-indent: 0;">大气测试点：空气测试环境，远程控制的样品平台</p>
                            <p style="font-size: 1.1em; text-indent: 0;">实验本底（20 x 20 mm<sup>2</sup>束斑）：&lt;1.4E-4(中子)，&lt;3.4E-5(伽玛)</p>
                            <h4 style="color: RGB(33, 150, 243);">用户服务</h4>
                            <p style="font-size: 1.1em; text-indent: 0;">联系人：敬罕涛 18937601342 jinght@ihep.ac.cn</p>
                            <p style="font-size: 1.1em; text-indent: 4em;">谭志新 18948323721 tanzhixin@ihep.ac.cn</p>
                            <p style="font-size: 1.1em; text-indent: 4em;">孙鹏宇 0769-88931160 sunpy@ihep.ac.cn</p>
                        </div>
                    </div>
                </div>
                <div class="p-col-12 p-md-4" style="border: 2px solid gray; border-radius: 0px;">
                     <div class="p-grid">
                        <div class="p-col-12" style="background-color: paleturquoise;">
                            <div v-if="false" class="showMore" @click="onShowMoreClick">
                                <i v-if="!showMore" class="fa fa-plus-square-o"></i>
                                <i v-if="showMore" class="fa fa-minus-square-o"></i>
                                <span> 更多</span>
                            </div>
                            <div style="text-align: center; color: RGB(33, 150, 243); font-size: 2em; font-weight: bold;">通知公告</div>
                        </div>
                        <!-- <div class="p-col-12" style="height: 300px; overflow-x: hidden; overflow-y: auto;"> -->
                        <div class="p-col-12" :style="{'overflow-y': showMore ? 'scroll' : 'hidden'}" style="height: 600px; overflow-x: hidden;">
                            <div v-for="notice of notices" :key="notice._id" class="notice" style="font-size: 1.1em; text-indent: 1em; margin-bottom: .2em;" @click="onDetailClick(notice)">
                                <span style="color: RGB(33, 150, 243); font-size: 1.2em; margin-right: .5em;">&#8226;</span>
                                <span>{{ notice.title }}</span>
                                <div style="float: right; color: dimgray;">
                                    {{ showDate(notice.updatedAt) }}
                                </div>
                            </div>
                            <div v-if="!notices || notices.length===0" style="color: orange; font-size: 1.2em;">暂无通知公告</div>
                        </div>
                    </div>
                </div>
                <div class="p-col-12" style="border: 2px solid gray; border-radius: 0px;">
                    <div class="p-grid">
                        <div class="p-col-12" style="background-color: paleturquoise;">
                            <div style="text-align: center; color: RGB(33, 150, 243); font-size: 2em; font-weight: bold;">技术支持</div>
                        </div>
                        <div class="p-col-12">
                            <p>联系人：王林</p>
                            <p>联系电话：0769-88931147</p>
                            <p>Email：wanglin@ihep.ac.cn</p>
                            <p>通讯地址：广东省东莞市大朗镇中子源路1号</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="layout-footer">
            <div class="p-grid">
                <div class="p-col-12 p-md-6  p-lg-3">
                    <span class="logo">伴生质子束用户系统</span>
                    <p>版权所有 ©2021 散裂中子源科学中心</p>
                </div>
                <div class="p-col-12 p-md-6 p-lg-3">
                    <span>相关链接</span>
                    <div class="p-grid">
                        <ul class="links">
                            <li> <a href="https://user.csns.ihep.ac.cn/">CSNS用户服务系统</a></li>
                            <li> <a href="https://backn.csns.ihep.ac.cn">Back-n用户系统</a></li>
                            <li> <a href="https://login.csns.ihep.ac.cn">CSNS统一认证系统</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Dialog v-model:visible="showNoticeDetailDialog" :modal="true" :closable="false" :style="{'min-width': '50vw'}" class="p-fluid">
        <template #header>
            <h3>{{ notice.title }}</h3>
        </template>

        <!-- <p style="white-space: pre-line">{{ notice.content }}</p> -->
        <Textarea v-model="notice.content" :autoResize="true" rows="5" cols="30" :disabled="true" />
        <div style="height: 1em;"></div>
        <div v-for="(attachment, index) of notice.attachments" :key="index" style="margin-bottom: 10px">
            <div v-if="attachment" style="color: RGB(33, 150, 243)">
                <span>附件{{ index + 1 }}： </span>
                <span>
                    <i v-if="['doc', 'docx'].includes(attachment.name.split('.').pop())" class="fa fa-fw fa-file-word-o" style="font-size: 1.1em; color: RGB(42, 86, 153)"></i>
                    <i v-else-if="['xls', 'xlsx'].includes(attachment.name.split('.').pop())" class="fa fa-fw fa-file-excel-o" style="font-size: 1.1em; color: RGB(31, 114, 70)"></i>
                    <i v-else-if="['pdf'].includes(attachment.name.split('.').pop())" class="fa fa-fw fa-file-pdf-o" style="font-size: 1.1em; color: RGB(250, 0, 0)"></i>
                    <i v-else class="fa fa-fw fa-file-text-o" style="font-size: 1.1em; color: dimgray"></i>
                </span>
                <a :href="attachmentUrl(notice._id, attachment._id)" target="_blank">
                    <span>{{ attachment.name }}</span>
                </a>
            </div>
        </div>

        <template #footer>
            <Button label="关闭" icon="pi pi-times" @click="showNoticeDetailDialog=false" class="p-button-text"/>
            <span style="float: left">{{ showDate(notice.updatedAt) }}</span>
        </template>
    </Dialog>

  </div>
</template>
      
    
<script>
const dateFormat = require('dateformat');
import NoticeService from '../service/NoticeService';

export default {
    data() {
		return {
            notice: {},
            notices: [],
			menuActive: false,
            showNoticeDetailDialog: false,
            showMore: false,
		}
	},
    noticeService: null,
	created() {
		this.noticeService = new NoticeService();
	},
	mounted() {
		this.loadNotices();
	},
    methods: {
        loadNotices() {
            this.noticeService.findNotices()
            .then(data => {
                this.notices = data;
            }).catch(error => {
                if(error.response) {
                    this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.response.data.message });
                } else {
                    this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
                }
            });
        },
        onMenuButtonClick(event) {
			if(this.menuActive) {
                this.hideMenu();
            } else {
                this.showMenu();
            }
			event.preventDefault();
		},
        showMenu() {
            this.menuActive = true;
        },
        hideMenu() {
            this.menuActive = false;
        },
        onShowMoreClick() {
            this.showMore = !this.showMore;
        },
        // onDetailClick(notice) {
        //     this.notice = notice;
        //     this.showNoticeDetailDialog = true;
        // },
        onDetailClick(n) {
            this.noticeService.findNotice(n._id).then((notice) => {
				this.notice = notice;
				this.showNoticeDetailDialog = true;
			});
        },
        attachmentUrl(noticeId, attachmentId) {
            return this.noticeService.attachmentUrl(noticeId, attachmentId);
		},
        showDate(value) {
            return dateFormat(value, "yyyy-mm-dd");
        },
        showTime(value) {
            return dateFormat(value, "HH:MM");
        },
        showDateTime(value) {
            return dateFormat(value, "yyyy-mm-dd HH:MM");
        },
    },
    computed: {
        isMobile() {
            // console.log(screen.width);
            // console.log(typeof screen.width);
            return screen.width <= 760 ? true : false;
        },
        screenWidth() {
            return screen.width;
        },
    }

}          
</script>


<style scoped>

.header-content {
    background: none !important;
    background-color: white !important;
}

.notice {
    cursor: pointer;
}

.notice:hover {
    color: RGB(33, 150, 243);
}

.notice:active {
  color: skyblue;
}

.showMore {
    float: right; 
    font-size: 1.2em; 
    padding: .3em; 
    color: dimgray;
    cursor: pointer;
}

.showMore:hover {
    color: RGB(33, 150, 243);
}

.showMore:active {
  color: skyblue;
}

.align-both-ends {
  text-align:justify;
  text-justify: inter-word;
/* text-align-last:center; */
}

</style> 
